"use strict";
exports.__esModule = true;
exports.SvgWorkflow = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgWorkflow = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", d: "M19.25 13.5V17h1.341c.38.005.409.06.409.508v4.032c-.008.455-.086.46-.733.46h-3.55c-.579-.003-.717-.042-.717-.557v-3.935c0-.448.105-.503.514-.508l1.236-.001V14.25h-10v2.749h.906c.644 0 .821.115.842.58l.002.104v3.614c0 .552-.154.702-.844.702L5.262 22c-.69 0-.762-.15-.762-.703v-3.614c0-.552.072-.683.762-.683h.988v-7H4a1 1 0 01-1-1V3a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H7.75v2.75H18.5a.75.75 0 01.75.75zm-9.683-10H4.5v5h5.067v-5z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Workflow.js.map